import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-appointment',
  templateUrl: './fh-svg-appointment.component.html',
  styleUrl: './fh-svg-appointment.component.scss'
})
export class FhSvgAppointmentComponent {
  @Input() color: string = '';
}
